import { observable, action, makeObservable, set } from 'mobx';

import { CashBoxType } from '../../shared/support/modelTypes';

export interface CashBoxFormStoreType {
	model: CashBoxType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude?: Array<any>;
	selectedItems: Array<any>;
	isFirstLoad: boolean;
	name: string;
	setValue(model: any, key: string, value: any): void;
}

class CashBoxFormStore implements CashBoxFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			selectedItems: observable,
			filterInclude: observable,
			isFirstLoad: observable,
			name: observable,
			setValue: action
		});
	}

	model = {
		bankCode: null,
		bankName: '',
		bankCorrAccount: null,
		bankCity: null,
		bankAddress: null,
		bankPhone: null,
		bankSwiftCode: null,
		bankItn: null,
		accountNumber: '',
		correspondentText: null,
		destinationText: null,
		bankBIC: null,
		name: { ru: '' },
		displayName: null,
		priority: null,
		deleted: false,
		ownerId: null,
		ownerType: 'OrmOrganization'
	};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	pluralName = 'cashBoxs';
	filterInclude = ['owner'];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	isFirstLoad = true;
	name = 'OrmCashBox';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const cashBoxFormStore = new CashBoxFormStore();

export default CashBoxFormStore;
